var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.orgId && _vm.orgName)?_c('div',[_c('BillingView',{attrs:{"organizationId":_vm.orgId,"organizationName":_vm.orgName,"billingFromDate":_vm.billingFromDate,"billingToDate":_vm.billingToDate,"billing_filter_val":_vm.billing_filter_val}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }